const productsData = [
  {
    id: 'integracion-programa',
    title: 'Acciones en Punto de Fe',
    product: 'Integración con Margarita Toledo',
    investment: 'Incluido en la alianza',
    impacts: [
      '«Conexión Nexus» (5–10 min): reflexión cultural y espiritual — música, arte, historia y sanación personal.',
      'Menciones de autoridad: Margarita presenta «Sanando con los Ángeles» como guía espiritual de los proyectos Nexus Cultural.',
      'Presencia visual de Nexus Cultural en el set de Punto de Fe (grabaciones en estudios TNO).',
    ],
  },
  {
    id: 'agenda-semanal-alma-cartelera',
    title: 'Alma en Cartelera',
    product: 'Agenda Nexus: en vivo + TNO Digest',
    investment: 'Cobertura semanal',
    impacts: [
      'Cada semana en vivo en Punto de Fe: Margarita promociona la agenda Nexus (fechas, encuentros, «Sanando con los Ángeles») con tono de alianza.',
      'TNO Digest — sección «Alma en Cartelera»: mismas convocatorias, SEO y redes, alineadas a lo dicho en antena.',
      'Coherencia antena + portal: la audiencia retoma la agenda en la web y quien llega por Google ve la misma marca en Punto de Fe.',
    ],
  },
  {
    id: 'ecosistema-digital',
    title: 'Ecosistema digital y frecuencia',
    product: 'TNO Digest + rotativa',
    investment: 'Rotativa & SEO',
    impacts: [
      'TNO Digest (SEO) en Google; ejemplo de titular: «Nexus Cultural: el nuevo epicentro de sanación y arte en Caracas» — «Sanando con los Ángeles» y propuesta cultural.',
      'Rotativa radio visual: 12 spots/día (20 s), música y mensajes de paz.',
      'Spot: «Nexus Cultural presenta: Un minuto para tu alma en Punto de Fe. La cultura que sana está en TNO Network.»',
    ],
  },
];

export default productsData;
